import { useState, useCallback, useEffect } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { getFormattedTimeLeft } from "app/components/discountCampaign/DiscountBanner/utils/helpers";
import type { IBannerTheme } from "app/components/React/TrialBanner/StyledTrialBanner";
import { useSeasonalCampaign } from "app/marketing/hooks/campaing-hooks/seasonal-campaign/useSeasonalCampaign";
import { useLocalStorage } from "app/pages/activation/hooks/helpers/useLocalStorage";
import { allTrackers } from "app/services/track/track";
import { getDateAsText } from "app/UtilitiesAndConstants/UtilityFunctions/timeAndDate";

interface IUseSeasonalCampaignBannerApi {
    isDiscarded: boolean;
    timerTheme: IBannerTheme;
    handleClose: () => void;
    onCtaClick: () => void;
}

const SEASONAL_CAMPAIGN_BANNER_STORAGE_KEY = "seasonal.campaign.banner.last.shown";

export const useSeasonalCampaignBanner = (): IUseSeasonalCampaignBannerApi => {
    const { discountEndDate, handleCtaClick } = useSeasonalCampaign();

    const { getLocalStorage, setLocalStorage } = useLocalStorage();

    const todayAsText = getDateAsText();
    const modalState = getLocalStorage(SEASONAL_CAMPAIGN_BANNER_STORAGE_KEY);

    const [isDiscarded, setIsDiscarded] = useState(modalState === todayAsText);

    const formattedTimeLeft = getFormattedTimeLeft({ discountEndTime: discountEndDate });

    const timerTheme: IBannerTheme = {
        counterColor: colorsPalettes.midnight[500],
        color: colorsPalettes.midnight[500],
        background: colorsPalettes.carbon[0],
    };

    const handleClose = useCallback(() => {
        allTrackers.dispatchTrackEvent(
            "internal link",
            "close",
            `discount banner/Flash Sale Q226/${formattedTimeLeft}`,
        );
        setLocalStorage(SEASONAL_CAMPAIGN_BANNER_STORAGE_KEY, todayAsText);
        setIsDiscarded(true);
    }, [formattedTimeLeft, setLocalStorage, todayAsText]);

    const onCtaClick = useCallback(() => {
        allTrackers.dispatchTrackEvent(
            "internal link",
            "click",
            `discount banner/Flash Sale Q226/${formattedTimeLeft}`,
        );
        handleCtaClick();
    }, [formattedTimeLeft, handleCtaClick]);

    useEffect(() => {
        if (!isDiscarded) {
            allTrackers.dispatchTrackEvent("banner", "show", `discount banner/Flash Sale Q226/${formattedTimeLeft}`);
        }
    }, [formattedTimeLeft, isDiscarded]);

    return {
        isDiscarded,
        timerTheme,
        handleClose,
        onCtaClick,
    };
};
